import { useEffect, useState } from "react";
import { Button, Typography } from "@mui/material";
import { useAgencyInfo } from "context/agency";
import { useUpdateAgencyConfig } from "queries/configurator";

const fieldStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "10px",
  border: "1px solid #ccc",
  fontSize: "16px",
  outline: "none",
};

function HelpCentre() {
  const [agency, Update] = useAgencyInfo();
  const [label, setLabel] = useState("Help Centre");
  const [link, setLink] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (agency?.help_centre_label || agency?.help_centre_link) {
      setLabel(agency?.help_centre_label || "Help Centre");
      setLink(agency?.help_centre_link || "");
    }
  }, [agency]);

  const saveHelpCentreMutation = useUpdateAgencyConfig(true);

  const handleSaveClick = async () => {
    setLoading(true);
    try {
      const { response } = await saveHelpCentreMutation.mutateAsync({
        _id: agency?._id,
        help_centre_label: label,
        help_centre_link: link,
      });
      if (response) {
        Update(response.data);
      }
    } catch (error) {
      console.log("An error occurred while saving the Help Centre details");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "block" }}>
      <div style={{ marginTop: "16px" }}>
        <div style={{ width: "100%", marginBottom: "16px" }}>
          <Typography
            sx={{
              display: "block",
              marginBottom: "6px",
              fontSize: "14px",
              fontWeight: "bold",
            }}
            variant="paragraph"
          >
            Name your help section. This is the label customers will see in the menu.
          </Typography>
          <input
            type="text"
            placeholder="Help Centre"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            style={fieldStyle}
          />
        </div>

        <div style={{ width: "100%" }}>
          <Typography
            sx={{
              display: "block",
              marginBottom: "6px",
              fontSize: "14px",
              fontWeight: "bold",
            }}
            variant="paragraph"
          >
            Help your clients find answers faster - add your Help Centre link
          </Typography>
          <input
            type="text"
            placeholder="https://maybetech.site/maybe-help-centre"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            style={fieldStyle}
          />
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px", width: "100%" }}>
        <Button
          onClick={handleSaveClick}
          disabled={loading}
          variant="contained"
          color="primary"
          sx={{ marginTop: "10px" }}
        >
          save
        </Button>
      </div>
    </div>
  );
}

export default HelpCentre;
